import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../SettingsPage/index.css';

const TermsConditionPage = () => {
    const navigate = useNavigate();

    return (
        <div className="settings-page-wrapper">
            <div className="settings-header">
                <span className="settings-back-arrow" onClick={() => navigate(-1)}>‹</span>
                <h1 className="settings-title">Terms & Conditions</h1>
            </div>

            <div className="settings-container-card text-content-card">
                <h2 className="text-content-title">Terms & Conditions</h2>

                <p className="text-content-paragraph">
                    By using this application, you agree to comply with and be bound by the following
                    terms and conditions. Please read them carefully before using our services.
                </p>

                <h3 className="text-content-subtitle">User Responsibilities</h3>
                <ul className="text-content-list">
                    <li>You must provide accurate and complete information.</li>
                    <li>You are responsible for maintaining the confidentiality of your account.</li>
                    <li>You agree not to misuse the application.</li>
                </ul>

                <h3 className="text-content-subtitle">Prohibited Activities</h3>
                <ul className="text-content-list">
                    <li>Unauthorized access to the system</li>
                    <li>Uploading harmful or illegal content</li>
                    <li>Violating any applicable laws</li>
                </ul>

                <h3 className="text-content-subtitle">Termination</h3>
                <p className="text-content-paragraph">
                    We reserve the right to suspend or terminate your access to the application
                    if you violate these Terms & Conditions.
                </p>

                <h3 className="text-content-subtitle">Contact Information</h3>
                <p className="text-content-paragraph">
                    Email: gullycinema@gmail.com<br />
                    Phone: 9000022211
                </p>
            </div>
        </div>
    );
};

export default TermsConditionPage;
